<div class="filter_cover">
    <form name="calcForm" [formGroup]="filterForm">
        <h5><b>Plot</b></h5>
        <div class="row">
            <div class="col-12 col-md-auto col-lg-auto col-xl-auto">
                <div class="plotHtlHolder" formGroupName="htl">
                    <h5>HTL</h5>
                    <div class="switch_group_htl">
                        <div class="row">
                            <div class="col-6 col-sm-6 col-md-12 col-lg-12 col-xl">
                                <div class="switch_item  ">

                                    <div class="form-check form-switch">
                                        <input type="checkbox" class="form-check-input mt-2" id="rightEarSwitch"
                                            formControlName="right">
                                        <label class="form-check-label" for="rightEarSwitch">Right Ear</label>
                                    </div>

                                </div>
                            </div>
                            <div class="col-6 col-sm-6 col-md-12 col-lg-12 col-xl">
                                <div class="switch_item ">
                                    <div class="form-check form-switch">
                                        <input type="checkbox" class="form-check-input mt-2" id="leftEarSwitch"
                                            formControlName="left">
                                        <label class="form-check-label" for="leftEarSwitch">Left Ear</label>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-12 col-md col-lg col-xl">
                <div class="plotMfHolder" formGroupName="mf2">
                    <h5>MF2</h5>
                    <div class="switch_group_mf2">
                        <div class="row ">
                            <div class="col border-end ">
                                <div class="row ">
                                    <div class="col-auto colHight32 my-auto">
                                        <div class="switch_item">

                                            <div class="form-check form-switch">
                                                <input type="checkbox" class="form-check-input mt-2"
                                                    id="rightEarSwitchMF" (change)="checkMF2Modification()"
                                                    formControlName="right">
                                                <label class="form-check-label" for="rightEarSwitchMF">Right
                                                    Ear</label>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col colHight32 p-0" *ngIf="this.filterForm.value.mf2.right">
                                        <div class="option-item">

                                            <label class="filterPill">
                                                <input class="custom-control-input" type="checkbox"
                                                    formControlName="aahl_r" value="" id="flexCheckDefault_r">
                                                <span class="filterPill-label" title="Age Related Hearing Loss">
                                                    <span class="filterIcon filterIcon--checkLight ">
                                                        <k-icon
                                                            [icon]="{type: 'kennedys', name: 'light-check'}"></k-icon>
                                                    </span>
                                                    ARHL
                                                </span>
                                            </label>

                                        </div>
                                        <div class="option-item">
                                            <label class="filterPill">
                                                <input class="custom-control-input" type="checkbox"
                                                    formControlName="aahl_pts_r" value="" id="flexCheckDefault_pts_r">
                                                <span class="filterPill-label"
                                                    title="Age Related Hearing Loss + Noise Induced Permanent Threshold Shift">
                                                    <span class="filterIcon filterIcon--checkLight ">
                                                        <k-icon
                                                            [icon]="{type: 'kennedys', name: 'light-check'}"></k-icon>
                                                    </span>
                                                    ARHL + NIPTS
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col">
                                <div class="row ">
                                    <div class="col-auto my-auto colHight32">
                                        <div class="switch_item">
                                            <div class="form-check form-switch">
                                                <input type="checkbox" class="form-check-input mt-2"
                                                    id="leftEarSwitchMF" (change)="checkMF2Modification()"
                                                    formControlName="left">
                                                <label class="form-check-label" for="leftEarSwitchMF">Left
                                                    Ear</label>
                                            </div>


                                        </div>
                                    </div>
                                    <div class="col my-auto colHight32 p-0" *ngIf="this.filterForm.value.mf2.left">
                                        <div class="option-item">
                                            <label class="filterPill">
                                                <input class="custom-control-input" type="checkbox"
                                                    formControlName="aahl_l" value="" id="flexCheckDefault_l">
                                                <span class="filterPill-label" title="Age Related Hearing Loss">
                                                    <span class="filterIcon filterIcon--checkLight">
                                                        <k-icon
                                                            [icon]="{type: 'kennedys', name: 'light-check'}"></k-icon>
                                                    </span>
                                                    ARHL
                                                </span>
                                            </label>

                                        </div>
                                        <div class="option-item">
                                            <label class="filterPill">
                                                <input class="custom-control-input" type="checkbox"
                                                    formControlName="aahl_pts_l" value="" id="flexCheckDefault_pts_l">
                                                <span class="filterPill-label"
                                                    title="Age Related Hearing Loss + Noise Induced Permanent Threshold Shift">
                                                    <span class="filterIcon filterIcon--checkLight ">
                                                        <k-icon
                                                            [icon]="{type: 'kennedys', name: 'light-check'}"></k-icon>
                                                    </span>
                                                    ARHL + NIPTS
                                                </span>
                                            </label>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>


        <div class="row ">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                <div class="button_holder text-end mt-3">

                    <button type="button" (click)="reset()" title="Cancel"
                        class="btn-dark-grey klaim_btn text-center mr-2">
                        Reset
                    </button>

                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </form>
</div>